<script setup>
import StatusIcon from '@/Pages/Common/StatusIcon.vue';
import ActionType, {
  getActionTypeFromStatus
} from '@/Common/Enum/ActionType.js';
import { NIGHTCRAWLER_CHECK_STATUS } from '@/Common/Classifiers/NightcrawlerCheckClassifier.js';
import ExplainDirectiveRow from '@/Pages/DomainAnalysis/Partials/ExplainDirectiveRow.vue';
import translateNightCrawlerCode from '@/Common/Classifiers/NightCrawlerTranslations.js';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { directive } = defineProps({
  title: String,
  part: String,
  directive: {
    type: Object,
    default: null
  },
  infoText: {
    type: String,
    default: null
  }
});

const tooltip = (() => {
  if (!directive) {
    return t('common.validation.no_errors');
  }

  const messages = directive.checks.reduce((acc, check) => {
    if (check.status !== NIGHTCRAWLER_CHECK_STATUS.OK) {
      acc.push(translateNightCrawlerCode(check));
    }
    return acc;
  }, []);

  return !messages.length
    ? t('common.validation.no_errors')
    : messages.join('\n');
})();
</script>

<template>
  <ExplainDirectiveRow v-if="directive !== null || infoText !== null">
    <div>{{ title }}</div>
    <div class="hidden md:block">{{ part }}</div>
    <template #detail>
      <div
        class="text-wrap break-all"
        :class="{
          'text-grey-800 font-light italic': directive === null
        }"
      >
        {{ directive?.value ?? infoText }}
        <slot name="detail"></slot>
      </div>
    </template>
    <template #icon>
      <StatusIcon
        v-if="!directive"
        v-tooltip="'Information'"
        :action-type="ActionType.INFO"
      />
      <StatusIcon
        v-else
        v-tooltip="tooltip"
        :action-type="getActionTypeFromStatus(directive.status)"
      />
    </template>
  </ExplainDirectiveRow>
</template>
